import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=d40930b4&scoped=true"
import script from "./AddTeacher.vue?vue&type=script&lang=js"
export * from "./AddTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40930b4",
  null
  
)

export default component.exports